// ABOUTME: Shared styling tokens for the auth experience (/auth/* screens).
// ABOUTME: Lives in shared so loaders outside pages/auth (post-login gate) can match them.

// Dark background of the in-app auth screens. Also applied to the full-screen
// loader shown right after login so auth → app doesn't flash a white frame.
export const AUTH_BG_CLASS = "bg-[#242b34]"
